import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import ZoneItem from './ZoneItem';
import ZoneHeader from './ZoneHeader';

import { copyZone } from '../actions/zoneTemplates';

import { getZoneTemplates, getIsCopying } from '../reducers/zoneTemplates';

export class SitePlans extends React.Component {
  zoneContent(zones) {
    if (zones.length) {
      return (
        <div>
          {zones.map(z => (
            <div>
              <ZoneItem key={z.id} zone={z} />
            </div>
          ))}
        </div>
      );
    }
    return <div className="ui message">Aucune zone associée à ce client</div>;
  }

  render() {
    const { copyZone, isCopying, disabled, zones, zoneTemplates } = this.props;

    return (
      <div>
        <ZoneHeader
          onCopy={copyZone}
          isCopying={isCopying}
          canAdd={!disabled}
          zoneTemplatesRef={zoneTemplates}
        />
        {this.zoneContent(zones)}
      </div>
    );
  }
}

SitePlans.propTypes = {
  zones: PropTypes.array.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  zones: state.form.form.sitePlans,
  zoneTemplates: getZoneTemplates(state),
  isCopying: getIsCopying(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  copyZone: zoneTemplateId =>
    dispatch(copyZone(ownProps.caseId, zoneTemplateId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SitePlans);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-study/components/SitePlans.js